@import "../../variables.scss";

.booking {
  &__wrapper {
    border: 1px solid #d0d0d0;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-template-rows: 1;
    margin: 10px 0 10px 0;
    @media (max-width: $size-lg) {
      grid-template-columns: 50% 50%;
      row-gap: 15px;
      grid-template-rows: auto auto;
    }
    @media (max-width: $size-sm) {
      grid-template-columns: 100%;
      grid-template-rows: auto auto auto auto;
      border: unset;
      width: 100%;
    }
  }

  //change order of grid layout on mobile
  &__section {
    &:nth-child(2) {
      @media (max-width: $size-sm) {
        grid-row: 3;
      }
    }
    &:nth-child(3) {
      @media (max-width: $size-sm) {
        grid-row: 2;
      }
    }
  }

  &__viewSchedule {
    margin-top: 10px;
    background-color: white;
    color: $color-grey;
    width: 70%;
  }

  &__titleWrapper {
    @media (max-width: $size-sm) {
      background-color: rgba(0, 30, 83, 0.2);
      padding: 15px;
    }
  }

  &__jobTitle {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__shiftType {
    color: $color-grey;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.3px;

    @media (max-width: $size-sm) {
      margin-top: 5px;
      color: black;
    }
  }

  &__companyName {
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.34px;
    margin-top: 2px;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__addressLine {
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.3px;
  }

  &__rates {
    @media (max-width: $size-sm) {
      padding-left: 1rem;
      padding-right: 2rem;
    }
  }

  &__rate {
    height: 40px;
    p {
      margin-bottom: 0;
    }
    &:nth-child(even) {
      background-color: rgba(0, 30, 83, 0.05);
    }
  }

  &__firstSubsection {
    height: 25%;

    @media (max-width: $size-lg) {
      height: unset;
    }
  }
}
